import { FC } from "react";
import { IInclusionRow } from "./TableWrapper";
import { Star } from "./Star";
import { NewCircle } from "./NewCircle";
import { Button } from "components/button/Button";
import { i18nService } from "services";

interface Props {
  row: IInclusionRow;
  rowIndex: number;
  expandedRowTitle: string | null;
  toggleRow: (title: string) => void;
  favorites?: string[];
  addToFavorites: (t: string) => void;
  removeFromFavorites: (t: string) => void;
}

export const InclusionTableRow: FC<Props> = ({
  row: {
    spotlight,
    title,
    organisation,
    type,
    target_audience,
    description,
    image,
    cta_attachment,
    cta_tool,
  },
  rowIndex,
  expandedRowTitle,
  toggleRow,
  favorites,
  addToFavorites,
  removeFromFavorites,
}) => {
  return (
    <>
      <tr
        key={rowIndex}
        className="table-overview__row"
        aria-label={`${i18nService.copy["table.openRow"]} ${rowIndex + 1}`}
        aria-controls={`${rowIndex}_desc`}
      >
        <td>
          <Star
            ariaLabel={i18nService.copy["table.addFavorite"]}
            filled={favorites && favorites.includes(title)}
            onClick={() => {
              favorites && favorites.includes(title)
                ? removeFromFavorites(title)
                : addToFavorites(title);
            }}
            tabIndex={0}
            isCheckbox
          />
        </td>
        <th
          className="table-overview__row__title"
          onClick={() => toggleRow(title)}
        >
          {spotlight && <NewCircle label="In de kijker" size="big" />}
          {title}
        </th>
        <td onClick={() => toggleRow(title)}>{organisation}</td>
        <td onClick={() => toggleRow(title)}>{type?.join(", ")}</td>
        <td onClick={() => toggleRow(title)}>{target_audience?.join(", ")}</td>
        <td onClick={() => toggleRow(title)}>
          {description && (
            <button
              className={`table-overview__open ${
                expandedRowTitle === title && "is-open"
              }`}
              aria-label={`${i18nService.copy["table.openRow"]} ${
                rowIndex + 1
              }`}
              aria-expanded={expandedRowTitle === title}
            ></button>
          )}
        </td>
      </tr>
      {expandedRowTitle === title && description && (
        <tr id={`${rowIndex}_desc`} className="table-overview__row__expanded">
          <td colSpan={6}>
            <div>
              <div>
                {description}

                <div className="download-container">
                  {cta_attachment?.map((url: string, i: number) => (
                    <Button
                      text={"Download"}
                      onClick={() => window.open(url)}
                      outline
                    />
                  ))}
                  {cta_tool && (
                    <Button
                      text={`Bekijk`}
                      onClick={() => window.open(cta_tool)}
                      outline
                    />
                  )}
                </div>
              </div>
              {image && <div>{<img src={image} alt={`${title}`} />}</div>}
            </div>
          </td>
        </tr>
      )}
    </>
  );
};
